import styled from 'styled-components';
import { COLOR_ORANGE } from '../../../assets/styles/colors';

export default styled.div`
  display: flex;
  align-items: center;
  padding: 2px 0;
  button {
    display: flex;
    align-items: center;
    background: none;
    border: none;
    svg {
      min-width: 27px;
    }
    small {
      margin-left: 16px;
      word-break: break-all;
      text-align: left;
    }
  }
  .status-box {
    margin-right: 18px;
    width: 24px;
    min-width: 24px;
    height: 24px;
    border-radius: 7px;
    position: relative;
    border: 1px solid rgba(63, 61, 86, 0.2);
    &:before {
      content: '';
      width: 18px;
      height: 18px;
      top: 2px;
      left: 2px;
      border-radius: 6px;
      background: ${COLOR_ORANGE};
      position: absolute;
      display: none;
    }
    &.active {
      border: 1px solid ${COLOR_ORANGE};
      &:before {
        display: block;
      }
    }
  }
`;
